import clsx from 'clsx';
import { default as NextLinkBase } from 'next/link';
import { PropsWithChildren } from 'react';

import { NextLinkProps, Underline } from './types';

// TODO: Change link in NextJs v13
const NextLink = (props: PropsWithChildren<NextLinkProps>) => {
  const { children, underline = Underline.none, classes, redirectStart, showCursorPointer, ariaLabel, ...rest } = props;

  const mapUnderlineClass = (): string => {
    const underlineVariants: Record<string, string> = {
      [Underline.none]: 'no-underline',
      [Underline.always]: 'underline',
      [Underline.hover]: 'no-underline hover:underline',
    };
    return underlineVariants[underline];
  };

  const combinedClassName = clsx(
    { 'cursor-pointer': showCursorPointer },
    { 'cursor-auto': !showCursorPointer },
    { 'pointer-events-none cursor-progress': redirectStart },
    mapUnderlineClass(),
    classes,
  );

  return (
    <NextLinkBase prefetch={false} className={combinedClassName} aria-label={ariaLabel} {...rest} href={rest.href}>
      {children}
    </NextLinkBase>
  );
};

export default NextLink;
